import { YouIndicatedYouHaveSeenAPsychiatrist } from "~/providers/utils/types/rawResponsesTypes";

export const formatPsychiatricInThePast = (
  answer: YouIndicatedYouHaveSeenAPsychiatrist[],
) =>
  answer.map(
    ({ what_years, precipitating_event_happen_for_you_to_seek_help }) =>
      `${what_years}, ${precipitating_event_happen_for_you_to_seek_help}`,
  );
